module.exports = __webpack_public_path__ + "assets/img/terminalPic12_app.d9f66780.png";